import { useLanguage } from "../i18n";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = t("marquee");
  const row = [...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-line bg-surface py-5">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif italic text-xl md:text-2xl text-ink/70">{item}</span>
                <span className="text-terra text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
